import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, ImprimirRenach } from './types';

export const INITIAL_STATE: ImprimirRenach = {
	status: 0,
	data: null,
};

export default function imprimirRenachReducer(
	state = INITIAL_STATE,
	action: ReducerAction,
): ImprimirRenach {
	return produce(state, draft => {
		switch (action.type) {
			case Types.IMPRIMIR_RENACH_REQUEST: {
				draft.data = INITIAL_STATE.data;
				draft.status = INITIAL_STATE.status;
				break;
			}
			case Types.IMPRIMIR_RENACH_SUCCESS: {
				draft.data = action.payload.data;
				draft.status = action.payload.status;
				break;
			}
			case Types.IMPRIMIR_RENACH_FAILURE: {
				draft.data = INITIAL_STATE.data;
				draft.status = action.payload.status;
				break;
			}
			case Types.IMPRIMIR_RENACH_CLEAR: {
				draft.data = INITIAL_STATE.data;
				draft.status = INITIAL_STATE.status;
				break;
			}
			default:
		}
	});
}
